import * as THREE from 'three/build/three.module.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { PixelShader } from 'three/examples/jsm/shaders/PixelShader.js';

// Selective Unreal Bloom - view-source:https://threejs.org/examples/webgl_postprocessing_unreal_bloom_selective.html
import frag from './shader.frag';
import vertex from './shader.vertex';

import World from '../common/World';

const EPS = 1e-5;

// Check out roughness mipmapper, sounds cool
// https://stackoverflow.com/questions/60704912/play-a-gltf-animation-three-js

export default class Main extends World {

	constructor() {

		super();

		this.cameraType = '3rd-person';

		this.dupes = [];

		this.init(require('url:./jjjohn.glb')).then(_ => {

			this.cameraControls.minAzimuthAngle = - Math.PI / 16;
			this.cameraControls.maxAzimuthAngle = Math.PI / 16;
			this.cameraControls.minPolarAngle = Math.PI * (7 / 16);
			this.cameraControls.maxPolarAngle = Math.PI * (9 / 16);

			this.cameraControls.mouseButtons.right = false;
			this.cameraControls.mouseButtons.wheel = false;
			this.cameraControls.touches.two = false;
			this.cameraControls.touches.three = false;

			this.camera.near = 0.25;
			this.camera.far = 250;

			// Fit the camera to a 13x13 box
			const geometry = new THREE.BoxGeometry(13, 13, 1);

			const material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
			const cube = new THREE.Mesh( geometry, material );
			cube.position.z = -4;
			this.scene.add( cube );


			this.cameraControls.fitToBox(cube);

			this.camera.position.set(0, 0, EPS, 0, 0, -10);


			this.scene.remove(cube);

			setTimeout(_ => this.cameraControls.saveState(), 25);

			this.scene.background = new THREE.Color("#062F46");
			this.scene.fog.color = new THREE.Color("#062F56");
			this.scene.fog.near = 1;
			this.scene.fog.far = 250;


			const cube2 = this.scene.getObjectByName("Cube");
			cube2.castShadow = false;

			const dupe2 = this.scene.getObjectByName("Dupe");
			dupe2.castShadow = false;

			const myobj = document.getElementById("loading");
			myobj.remove(); 

			// bloom
			/*const bloomPass = new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 );
			bloomPass.threshold = 0;
			bloomPass.strength = .1;
			bloomPass.radius = 0;
			bloomPass.exposure = 2;
			this.composer.addPass(bloomPass);*/

			// pixellate
			/*const pixelPass = new ShaderPass( PixelShader );
			pixelPass.uniforms["resolution"].value = new THREE.Vector2(window.innerWidth, window.innerHeight);
			pixelPass.uniforms["resolution"].value.multiplyScalar(window.devicePixelRatio);
			pixelPass.uniforms[ "pixelSize" ].value = 2;
			this.composer.addPass(pixelPass);*/

			this.createDupes();

		});

		document.addEventListener('pointerup', (event) => {
			this.cameraControls.reset(true);
		});

		function preventBehavior(e) {
    		e.preventDefault(); 
		};

		document.addEventListener("touchmove", preventBehavior, {passive: false});

		

		this.cameraControls.addEventListener('update', _ => this.controlDupes());
		

	}

	/**
	 * [controlDupes description]
	 */
	controlDupes() {
		const po = this.cameraControls.polarAngle - Math.PI / 2;
		const az = this.cameraControls.azimuthAngle;

		this.dupes.forEach((dupe, i) => {
			dupe.position.y = - po * i * 7.5 * (0.25 + i / 250);
			dupe.position.x = - az * i * 7.5 * (0.25 + i / 250);
			dupe.rotation.set(0, 0, (az / 6) * i);
		})
	}

	/**
	 * [createDupes description]
	 */
	createDupes() {

		const dupe = this.scene.getObjectByName("Dupe");

		for(let x = 0; x < 200; x ++) {
			const newDupe = dupe.clone(true);
			newDupe.castShadow = false;
			newDupe.receiveShadow = false;
			newDupe.position.z = 0 - (x*3) - 10;
			this.dupes.push(newDupe);
			this.scene.add(newDupe);
		}

		
	}

	renderLoop(t) {
		super.renderLoop(t);
	}

}